import axios from "./AxiosClient";

const url = `/api`;

const SalesService = {
  getSales: (page = 1, route = "", filterData, searchKey) => {
    const { status = "", type = "", from = "", to = "" } = filterData;

    let queryParam = "";

    if (status !== "") {
      queryParam += `&form_status_id=${status}`;
    }
    if (type !== "") {
      queryParam += `&form_type=${type}`;
    }
    if (from !== "") {
      const fromDate = from.split("T")[0];
      queryParam += `&start_date=${fromDate}`;
    }

    if (to !== "") {
      const toDate = to.split("T")[0];
      queryParam += `&end_date=${toDate}`;
    }
    if (searchKey !== "") {
      queryParam += `&form_name=${searchKey}`;
    }

    return axios.get(`${url}/forms?page=${page}&route=${route}${queryParam}`);
  },
  fetchSale: (formId) => {
    return axios.get(`${url}/forms/show/${formId}`);
  },
  fetchSalevalidStates: (formId) => {
    return axios.get(`${url}/forms/getValidStates/${formId}`);
  },
  addUpdateForm: (payload) => {
    return axios.post(`${url}/forms/add`, payload);
  },
  deleteForm: (formId) => {
    return axios.get(`${url}/forms/delete/${formId}`);
  },
  pdfGeneration: (formId, type) => {
    return axios.get(`${url}/forms/pdf/${formId}?type=${type}`, {
      responseType: "blob",
    });
  },
// Products

  addUpdateProducts: (payload) => {
    return axios.post(`${url}/products/add`, payload);
  },
  fetchSaleProduct: (productId) => {
    return axios.get(`${url}/products/show/${productId}`);
  },
  fetchProductValidStates: (productId) => {
    return axios.get(`${url}/products/getValidStates/${productId}`);
  },
  fetchProductsWithFormID: (formId) => {
    return axios.get(`${url}/products/${formId}`);
  }
};

export default SalesService;
